import { fetchWithWidgetToken } from './fetchWithWidgetToken';

const FETCH_DELAY = 5000;
const MAX_FETCH_ATTEMPTS = 15;

export function poll<T>(
  fetchURL: string,
  widgetToken: string | undefined,
  shouldStop?: (data: T) => boolean
) {
  let requestCount = 0;
  const errorMessage = `Too many attempts to fetch source: ${fetchURL}`;

  const pollRequest = (
    resolve: (value: T) => void,
    reject: (reason?: unknown) => void
  ) => {
    if (requestCount >= MAX_FETCH_ATTEMPTS) {
      reject(errorMessage);

      return;
    }

    fetchWithWidgetToken({ url: fetchURL, widgetToken })
      .then((response) => {
        if (!response.ok) {
          console.error('Network error');
        }

        return response.json() as T;
      })
      .then((data) => {
        requestCount += 1;

        if (shouldStop?.(data)) {
          resolve(data);
        } else if (requestCount < MAX_FETCH_ATTEMPTS) {
          setTimeout(() => pollRequest(resolve, reject), FETCH_DELAY);
        } else {
          reject(errorMessage);
        }
      })
      .catch((error) => {
        console.error('Error while polling:', error);
        requestCount += 1;

        if (requestCount < MAX_FETCH_ATTEMPTS) {
          setTimeout(() => pollRequest(resolve, reject), FETCH_DELAY);
        } else {
          reject(errorMessage);
        }
      });
  };

  return new Promise<T>((resolve, reject) => {
    pollRequest(resolve, reject);
  });
}
